export const EVENTS = {
	SAVE: 'SAVE',
	EDIT: 'EDIT',
	CANCEL: 'CANCEL'
}